<template>
  <p>
    El ceilómetro CHM15k es un equipo que emplea la tecnología lidar para
    realizar mediciones atmosféricas. Su principio de medición es la emisión de
    un pulso láser en la longitud de onda de 1064 nm para realizar mediciones
    con un alcance de 15 km de altura, con una resolución vertical de hasta 5 m
    y temporal de hasta 2 segundos. Se emplea fundamentalmente para la obtención
    de perfiles sobre concentración de aerosoles
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/ceilometro.webp"
    alt="Ceilómetro"
  />

  <p>
    Otras características técnicas importantes:
  </p>
  <List marked>
    <li>Fuente de luz: Nd:YAG laser de estado sólido</li>
    <li>Energía por pulso: 7 µJ</li>
    <li>Frecuencia de repetición: 5 - 7 kHz</li>
    <li>Ancho de banda del filtro: 1 nm</li>
    <li>Campo de visión del receptor: 0.45 mrad</li>
  </List>
  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Perfiles verticales de retrodispersión por aerosoles</li>
    <li>Altura de la capa de aerosoles</li>
    <li>Altura de la base de las nubes</li>
    <li>Espesor de las nubes</li>
    <li>Cobertura de nubes</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    Lufft, CHM15k
  </p>

  <p>
    <b>País: </b> <br />
    Alemania.
  </p>

  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.lufft.com/products/cloud-height-snow-depth-sensors-288/ceilometer-chm-15k-nimbus-2300/"
      target="_blank"
      >https://www.lufft.com/products/cloud-height-snow-depth-sensors-288/ceilometer-chm-15k-nimbus-2300/</a
    >
  </p>

  <p>
    <b>Responsable: </b> <br />
    restevan@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
